<script setup>
  import { useAttrs } from 'vue';

  const props = defineProps({
    placeholder: { type: String, default: null },
    prefix:      { type: String, default: null },
    suffix:      { type: String, default: ' %' },
    size:        { type: String, default: 'small' },
    minDigits:   { type: Number, default: 0 },
    maxDigits:   { type: Number, default: 4 },
  })

  const model = defineModel()
  const attrs = useAttrs()
</script>

<template lang="pug">
InputNumber(
  v-model="model"
  v-bind="attrs"
  :placeholder="placeholder"
  :minFractionDigits="minDigits"
  :maxFractionDigits="maxDigits"
  :prefix="prefix"
  :suffix="suffix"
  :size="size"
  locale="en-US"
)
</template>